import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("aceh_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // Do not force-remove during initial /auth/me check on public routes
    }
    return Promise.reject(err);
  }
);

export function saveToken(t) {
  if (t) localStorage.setItem("aceh_token", t);
}
export function clearToken() {
  localStorage.removeItem("aceh_token");
}
